import {
  FETCH_WALLET_FAIL,
  FETCH_WALLET_REQUEST,
  FETCH_WALLET_SUCCESS,
} from "../constants";

export const fetchWalletReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_WALLET_REQUEST:
      return { ...state, loading: true };
    case FETCH_WALLET_SUCCESS:
      return { wallet: action.payload, loading: false };
    case FETCH_WALLET_FAIL:
      return { error: action.payload, loading: false };
    default:
      return state;
  }
};
